
import { Message } from 'element-ui';
import dayjs from 'dayjs';
import _ from 'lodash';
import { validateSearchTime } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/components/util/index.js';
import {  strToArray }  from '@/modules/transport/otp/utils/commonFun';

export const formatSearchData = (data) => {
    const params = _.cloneDeep(data);
    params.siteCodeList = params.siteCode ? params.siteCode.split(',') : [];
    params.siteNameList = params.siteName ? params.siteName.split(',') : [];
    params.carrierCodeList = params.carrierCode ? params.carrierCode.split(',') : [];
    params.carrierNameList = params.carrierName ? params.carrierName.split(',') : [];
    params.vehicleCardList = params.vehicleCard ? params.vehicleCard.split(',') : [];
    params.driverList = params.driver ? params.driver.split(',') : [];
    params.firstMonitorStartTime = params.firstMonitorTime ? dayjs(params.firstMonitorTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.firstMonitorEndTime = params.firstMonitorTime ? dayjs(params.firstMonitorTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchStartTime = params.dispatchTime ? dayjs(params.dispatchTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchEndTime = params.dispatchTime ? dayjs(params.dispatchTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.newMonitorStartTime = params.newMonitorTime ? dayjs(params.newMonitorTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.newMonitorEndTime = params.newMonitorTime ? dayjs(params.newMonitorTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    if (params.monitorStatus.length) {
        if (params.monitorStatus.length === 1) {
            params.monitorStatus = params.monitorStatus.join('');
        } else {
            params.monitorStatus = '3';
        }
    } else {
        params.monitorStatus = '';
    }
    delete params.siteName;
    delete params.siteCode;
    delete params.carrierName;
    delete params.carrierCode;
    delete params.vehicleCard;
    delete params.firstMonitorTime;
    delete params.dispatchTime;
    delete params.newMonitorTime;
    return params;
};

export const validateSearchData = (data) => {
    const isExitTime = (data.dispatchStartTime && data.dispatchEndTime) || (data.firstMonitorStartTime && data.firstMonitorEndTime);
    if (!isExitTime && !data.dispatchNo) {
        Message.warning('发车单号、发车时间、首次预警时间不可同时为空');
        return false;
    }
    return validateSearchTime(data, 'dispatchStartTime', 'dispatchEndTime', 61) &&
        validateSearchTime(data, 'firstMonitorStartTime', 'firstMonitorEndTime', 61);
};

export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(item => {
        item.loadingMethod = (item.loadQty || 0) + '装' + (item.unloadQty || 0) + '卸';
        item.earlyWarningGradeName = dictData.BUNCH_GOODS_EARLY_WARNING_GRADE[item.earlyWarningGrade];

        // 多个行业，用"+"符号连接
        item['__industryCategory__'] = strToArray(item.industryCategory).map(item => {
            return dictData.SYS_SUPPLIER_INDUSTRY[item];
        }).filter(Boolean).join(' + ');

    });
    return data;
};
